<p *ngIf="hasData" class="po-font-text-small po-mb-2">
  {{ contextLabel }}
  <span class="po-icon po-icon-info" [p-tooltip]="columnHelp"
    p-tooltip-position="bottom" p-append-in-body="true"></span>
</p>
<p *ngIf="undetailedLabel" class="po-font-text-small po-mb-2">{{ undetailedLabel }}</p>

<!-- Busca sozinha numa linha cheia e o filtro de categoria embaixo, à parte — misturar
     po-search com po-multiselect na mesma linha não alinha (ver Ranking de fontes). -->
<div class="po-row po-mb-2">
  <po-search
    class="po-sm-12"
    p-aria-label="Pesquisar nos reviews que pedem ação"
    p-search-type="trigger"
    [p-literals]="searchLiterals"
    (p-change-model)="searchReviews($event)">
  </po-search>
</div>

<div class="po-row po-mb-2">
  <po-multiselect
    name="attentionCategory"
    class="po-sm-12 po-md-6"
    p-label="Categoria"
    p-placeholder="Todas as categorias"
    p-filter-mode="contains"
    [p-options]="categoryOptions"
    [ngModel]="selectedCategories"
    (ngModelChange)="categoriesChanged($event)">
  </po-multiselect>

  <po-multiselect
    p-filter-mode="contains"
    name="attentionSeverity"
    class="po-sm-12 po-md-6"
    p-label="Severidade"
    p-placeholder="Todas as severidades"
    [p-options]="severityOptions"
    [ngModel]="selectedSeverities"
    (ngModelChange)="severitiesChanged($event)">
  </po-multiselect>
</div>

<po-table
  *ngIf="hasData || loading; else emptyAttention"
  class="attention-table"
  [p-columns]="columns"
  [p-items]="rows"
  [p-actions]="actions"
  p-actions-right="true"
  [p-height]="height"
  [p-hide-table-search]="true"
  [p-hide-columns-manager]="true"
  [p-loading]="loading"
  [p-show-more-disabled]="allRowsVisible"
  (p-show-more)="showMore()">

  <ng-template p-table-column-template [p-property]="'reviewCell'" let-value>
    <div class="attention-table__review">
      <span class="po-font-text-bold">{{ value.title }}</span>
      <span class="po-font-text-small">{{ value.subtitle }}</span>
    </div>
  </ng-template>

  <ng-template p-table-column-template [p-property]="'findingsCell'" let-value>
    <div class="attention-table__tags">
      <span *ngFor="let tag of value.tags" [title]="tag.title || ''">
        <po-tag [p-value]="tag.label" [p-type]="tag.type" p-inverse="true"></po-tag>
      </span>
    </div>
  </ng-template>
</po-table>

<ng-template #emptyAttention>
  <p class="po-font-text-small" *ngIf="!loading && !loadError && search">Nenhum review encontrado para "{{ search }}".</p>
  <p class="po-font-text-small" *ngIf="!loading && !loadError && !search">Nenhum review com ação ALTA ou arquivo rejeitado neste recorte.</p>
  <p class="po-font-text-small" *ngIf="loadError">Não foi possível carregar a lista.</p>
</ng-template>
